import { englishMessages } from './common';

export default {
  ...englishMessages,
  CONFIGURATOR: ' Build & Price',
};
